<template>
   
    <section v-if="story" id="hero-form-coisar" class="hero pt-20 lg:pt-32 pb-12 mb-12 bg-[url('/Coisar_Hero_BG.jpg')] bg-cover bg-center bg-fixed bg-no-repeat overflow-hidden">
        <div class="container grid grid-cols-1 lg:grid-cols-[55%_40%] gap-4 lg:gap-[5%] items-stretch">
            <!-- Hero Content -->
            <StoryblokComponent v-if="story" :blok="story.content.hero[0]" class="order-2 lg:order-1" />
            <!-- Hero Coisar Form -->
            
            <div class="hero-form-coisar p-3 rounded-3xl items-stretch bg-slate-500 bg-opacity-30 order-1 lg:order-2">
                <form @submit.prevent="register()">
                    <div class="coisar-form flex flex-col gap-4 bg-white py-4 md:py-8 px-6 md:px-12 rounded-3xl">
                        <h2 class="landing-h3 text-black">{{ $gettext("Create your free Human Design Chart") }}</h2>
                        <fieldset>
                            <label for="reading-name">{{ $gettext("First and Last Name") }} *</label>
                                <div>
                                    <input :placeholder="$gettext('First and Last Name')" type="text" id="reading-name" v-model="fullName" autocomplete="off"

                                        :class="[v$.fullName.$error ?
                                            'border-red-200 text-red-500/90 focus:ring-red-500/90 focus:border-red-500/90' :
                                            'border-blue-200 focus:ring-blue-500/90 text-blue-500/90',
                                            'shadow-sm block font-semibold w-full text-sm focus:bg-whitesmoke-100  border-2 rounded-xl ']" />
                                </div>
                        </fieldset>
                        <fieldset>
                            <label for="reading-datetime">{{ $gettext("Date and time of birth") }} *</label>
                            <div>
                                <DateTimeInput v-model="birthDatetime" name="reading-datetime" :v="v$.birthDatetime" />
                            </div>
                        </fieldset>
                        <fieldset>
                                <label for="reading-location">{{ $gettext("Place of birth") }} *</label>
                                <div>
                                    <LocationAutocomplete v-model="birthLocation" name="reading-location" :placeholder="$gettext('Place of birth')"
                                        :v="v$.birthLocation" />
                                </div>
                        </fieldset>
                        <fieldset>
                                <label for="user-email-location">{{ $gettext("Email") }} *</label>
                                <div >
                                    <input type="email" :placeholder="$gettext('Your Email')" name="user-email" v-model="userEmail" id="user-email" autocomplete="off"
                                        
                                        :class="[v$.userEmail.$error ?
                                            'border-red-200 text-red-500/90 focus:ring-red-500/90 focus:border-red-500/90' :
                                            'border-blue-200 focus:ring-blue-500/90 text-blue-500/90',
                                            'shadow-sm block font-semibold w-full text-sm focus:bg-whitesmoke-100  border-2 rounded-xl ']" />
                                </div>
                        </fieldset>
                        <fieldset>
                                <label for="user-password">{{ $gettext("Password") }} *</label>
                                <div>
                                    <input type="password" :placeholder="$gettext('Password')" name="user-password" v-model="password" id="user-password"
                                        autocomplete="off" 
                                        :class="[v$.password.$error ?
                                            'border-red-200 text-red-500/90 focus:ring-red-500/90 focus:border-red-500/90' :
                                            'border-blue-200 focus:ring-blue-500/90 text-blue-500/90',
                                            'shadow-sm block font-semibold w-full text-sm focus:bg-whitesmoke-100  border-2 rounded-xl ']" />
                                </div>
                        </fieldset>
                        <fieldset>
                            <div>
                                <input id="user-accept-terms" name="accept" type="checkbox" v-model="acceptTerms" 
                                    :class="[v$.acceptTerms.$error ?
                                        'border-red-200 text-red-500/90 focus:ring-red-500/90 focus:border-red-500/90' :
                                        'border-blue-200 focus:ring-blue-500/90 text-blue-500/90',
                                        'h-5 w-5 mr-1 focus:bg-whitesmoke-100 border-2 rounded']" />
                                        
                                <label for="user-accept-terms">{{ $gettext('I accept the') }} <router-link class="text-blue-500/90"  target="_blank"
                                            :to="{ name: 'legal', params: { type: 'privacy' } }">{{ $gettext('Privacy Policy') }}</router-link> {{ $gettext('and') }} <router-link class="text-blue-500/90" target="_blank"
                                            :to="{ name: 'legal', params: { type: 'terms' } }">{{ $gettext('Terms of Use') }}</router-link> {{ $gettext('and') }} <router-link class="text-blue-500/90" target="_blank"
                                            :to="{ name: 'legal', params: { type: 'cookies' } }">{{ $gettext('Cookie Policy') }}</router-link>.</label>
                            </div>
                        </fieldset>

                        <transition enter-active-class="transition duration-100 ease-out"
                            enter-from-class="transform scale-95 opacity-0"
                            enter-to-class="transform scale-100 opacity-100"
                            leave-active-class="transition duration-75 ease-out"
                            leave-from-class="transform scale-100 opacity-100"
                            leave-to-class="transform scale-95 opacity-0">
                            <div v-if="v$.$errors?.length > 0" class="bg-red-50 p-4 rounded-md">

                                <div class="flex">
                                    <div class="flex-shrink-0">
                                        <font-awesome-icon size="xl" class="text-rose-400"
                                            :icon="['fasr', 'triangle-exclamation']" />
                                    </div>
                                    <div class="ml-3">
                                        <p class="font-['Plus font-semibold text-rose-400 text-sm Jakarta Sans']">
                                            {{ v$.$errors[0]?.$message }}</p>
                                    </div>
                                
                                </div>
                            </div>
                        </transition>
                        
                        <fieldset>
                            <button type="submit" class="btn-primary">{{ $gettext("Create Chart") }}</button>
                        </fieldset>
                    </div>
                </form>
            </div>
        </div>
    </section>

    <StoryblokSection v-if="story" v-for="currentBlok in story.content?.sections":key="currentBlok._uid" :blok="currentBlok" @pdf-section-cta-click="scrollToForm" />

</template>

<script setup>

import { computed, onMounted, ref, watch } from 'vue'

const isMobileMenuOpen = ref(false)




import {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
} from '@headlessui/vue'

import { useRouter, useRoute } from 'vue-router';
import { useUserStore } from '/src/stores/user.js';
import { useApplicationStore } from '/src/stores/application.js';


import { useVuelidate } from '@vuelidate/core';
import { required, email, helpers, minLength } from '@vuelidate/validators';

import DateTimeInput from '/src/components/DateTimeInput.vue';
import LocationAutocomplete from '/src/components/LocationAutocomplete.vue';

import StoryblokSection from '/src/components/Sections/StoryblokSection.vue'
import { useGettext } from 'vue3-gettext'
const { $gettext } = useGettext();


import { useStoryblok } from "@storyblok/vue";

const applicationStore = useApplicationStore()
const story = ref(null);

async function loadStory() {
  const storyData = await useStoryblok("landing", {
    language: applicationStore.currentLocale,
    version: import.meta.env.VITE_APP_STORYBLOK_VERSION,
  });
  story.value = storyData.value;

  console.log(story.value);
}

const scrollToForm = () => {
    window.location.hash = 'hero-form-coisar'
}

// Initial load
loadStory();

// Watch for language changes
watch(() => applicationStore.currentLocale, () => {
  loadStory();
});


const route = useRoute();

const scrollTo = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}

const userStore = useUserStore()
const router = useRouter()

const userEmail = ref();
const password = ref();
const fullName = ref();
const birthDatetime = ref();
const birthLocation = ref();
const acceptTerms = ref();
const $externalResults = ref({}) 

const rules = computed(() => ({
    fullName: {
        required: helpers.withMessage($gettext('Please enter your full name.'), required)
    },
    birthDatetime: {
        required: helpers.withMessage($gettext('Please enter your date and time of birth.'), required)
    },
    birthLocation: {
        required: helpers.withMessage($gettext('Please enter your place of birth.'), required)
    },
    userEmail: {
        required: helpers.withMessage($gettext('Please enter your email address.'), required),
        email: helpers.withMessage($gettext('Please enter a valid email address.'), email)
    },
    password: {
        required: helpers.withMessage($gettext('Please enter a password.'), required),
        minLength: helpers.withMessage($gettext('The password must contain at least 8 characters, including an uppercase letter and a number.'), minLength(8))
    },
    acceptTerms: {
        required: helpers.withMessage($gettext('Please accept the terms of use.'), required)
    },
    server: {
         true: () => true
    }
}))

const v$ = useVuelidate(rules, {
    fullName,
    birthDatetime,
    birthLocation,
    userEmail,
    password,
    acceptTerms
}, { $externalResults }, {$autoDirty: true,})


const register = async () => {

    try {
        v$.value.$clearExternalResults()

        const isFormCorrect = await v$.value.$validate()
        if (!isFormCorrect) {
            return
        }
        window.scrollTo(0,0)
        useApplicationStore().setLoading(true);

        const result = await userStore.register(userEmail.value, password.value, fullName.value, birthDatetime.value, birthLocation.value.location, birthLocation.value.timeZone, applicationStore.currentLocale)

        watch(result,
            (newReading) => {
                if (newReading?.status == "success") {
                    useApplicationStore().setLoading(false);
                    //@todo: needs realc fix by refactoring html base layout
                    //router.push('/reading/dashboard')
                    window.location.href = '/reading/dashboard'
                }
            },
            { deep: true }
        )

    } catch (e) {

        console.error(e)
        useApplicationStore().setLoading(false);

        const firebaseError = e.code;

        switch (firebaseError) {
            case 'auth/weak-password':
                $externalResults.value = {
                    password: $gettext('The password must contain at least 8 characters, including an uppercase letter and a number.')
                }
                break;
            case 'auth/email-already-in-use':
                $externalResults.value = {
                    userEmail: $gettext('Email is already in use.')
                }
                break;
            default:
                $externalResults.value = {
                    server: $gettext('An error occurred. Please try again.')
                }
        }
    }
}

</script>
